import { t, Trans } from '@lingui/macro'
import { Box, Typography, Stack, Grid, Tooltip, Dialog, DialogTitle, DialogContent } from '@mui/material'
import BlurOnIcon from '@mui/icons-material/BlurOn'

import colors from '@/assets/scss/_themes-vars.module.scss'
import { useGetEstablishmentBackgroundsQuery } from '@/core/services/establishment'
import { useAppSelector } from '@/redux/rootReducer'
import { selectAuthUser } from '@/redux/reducers/auth.reducer'
import { skipToken } from '@reduxjs/toolkit/query'

import { useChimeBackground } from '../model/useChimeBackground'
import { BackgroundEffectButton } from './BackgroundEffectButton'

export function BackgroundEffectModal({ open, onClose }: { open: boolean; onClose: () => void }) {
  const authUser = useAppSelector(selectAuthUser)
  const establishmentId = authUser?.establishment?._id
  const { data: backgrounds } = useGetEstablishmentBackgroundsQuery(establishmentId ? { establishmentId } : skipToken)

  const { effectConfig, toggleBlurEffect, toggleBackgroundEffect } = useChimeBackground()

  return (
    <Dialog fullWidth maxWidth="sm" open={open} onClose={onClose}>
      <DialogTitle>
        <Trans>Background effect</Trans>
      </DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          <Box bgcolor={colors.indigo50} borderRadius={2} p={2}>
            <Typography variant="subtitle1" mb={2}>
              <Trans>Blur</Trans>
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={3}>
                <Tooltip placement="top" title={t`Blur your background`}>
                  <BackgroundEffectButton active={effectConfig?.backgroundBlur?.isEnabled} onClick={toggleBlurEffect}>
                    <BlurOnIcon fontSize="large" />
                  </BackgroundEffectButton>
                </Tooltip>
              </Grid>
            </Grid>
          </Box>
          <Box bgcolor={colors.indigo50} borderRadius={2} p={2}>
            <Typography variant="subtitle1" mb={2}>
              <Trans>Backgrounds</Trans>
            </Typography>
            <Grid container spacing={2}>
              {backgrounds?.map((document) => (
                <Grid item xs={3} key={document.key}>
                  <BackgroundEffectButton active={effectConfig?.backgroundReplacement?.backgroundImageURL === document.url} sx={{ overflow: 'hidden', p: 0 }}>
                    <img
                      src={document.url}
                      alt="background image"
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        cursor: 'pointer',
                      }}
                      onClick={() => {
                        toggleBackgroundEffect(document.url, document.key)
                      }}
                    />
                  </BackgroundEffectButton>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Stack>
      </DialogContent>
    </Dialog>
  )
}
